import { forwardRef, useImperativeHandle, useState } from "react";

export interface DialogButton {
  text: string;
  type: 'primary' | 'secondary';
  onClick: () => void;
}

export interface DialogConfig {
  title: string;
  content: string;
  buttons: DialogButton[];
}

export interface CommonDialogRef {
  show: (config: DialogConfig) => void;
  hide: () => void;
}

const CommonDialog = forwardRef<CommonDialogRef, {}>((_, ref) => {
  const [visible, setVisible] = useState(false);
  const [config, setConfig] = useState<DialogConfig>({
    title: '',
    content: '',
    buttons: []
  });

  const show = (newConfig: DialogConfig) => {
    setConfig(newConfig);
    setVisible(true);
  };

  const hide = () => {
    setVisible(false);
  };

  const handleButtonClick = (button: DialogButton) => {
    button.onClick();
    hide();
  };

  useImperativeHandle(ref, () => ({
    show,
    hide,
  }));

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-9999 flex items-center justify-center">
      {/* 遮罩层 */}
      <div className="absolute inset-0 bg-black/50" />

      {/* 对话框内容 */}
      <div className="relative w-80 bg-white rounded-2 p-6 shadow-lg">
        <div className="text-3.5 font-500 text-mx-secondary lh-5.5 mb-2">
          {config.title}
        </div>

        <div className="text-3.5 text-mx-secondary mb-6 lh-5.5">
          {config.content}
        </div>

        <div className="flex justify-end gap-4">
          {config.buttons.map((button, index) => (
            <button
              key={index}
              className={
                button.type === 'primary'
                  ? "px-4 h-8 rounded-1.5 bg-#4981F2 text-3.5 text-white cursor-pointer border-none"
                  : "px-4 h-8 rounded-1.5 border-1 border-solid border-#ECEEF3 text-3.5 text-mx-secondary cursor-pointer bg-#fff"
              }
              onClick={() => handleButtonClick(button)}
            >
              {button.text}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
});

CommonDialog.displayName = "CommonDialog";

export default CommonDialog;

